<div class="main-layout">
  <app-header></app-header>

  <div class="main-layout__body">
    <main class="main-layout__content" id="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>

  <app-bottom-nav></app-bottom-nav>
</div>
